import { forwardRef, useId } from 'react'

import { clsx } from 'clsx'

import { FloatingInputProps } from 'shared/ui/date-picker-label/model.ts'

import s from './styles.module.scss'

export const FloatingInput = forwardRef<HTMLInputElement, FloatingInputProps>(
  ({ value, label, error, rightIcon, variant = 'default', onClick }, ref) => {
    const reactId = useId()
    const id = `dp-${reactId}`

    return (
      <div className={s.wrapper}>
        <div
          className={clsx(
            s.container,
            s[`variant-${variant}`],
            error && s.error,
          )}
        >
          <input
            ref={ref}
            id={id}
            value={value || ''}
            placeholder=" "
            readOnly
            onClick={onClick}
            className={s.input}
          />

          <label
            htmlFor={id}
            className={s.label}
          >
            {label}
          </label>

          <div className={s.rightIcon}>{rightIcon}</div>
        </div>
      </div>
    )
  },
)

FloatingInput.displayName = 'FloatingInput'
